import { render, staticRenderFns } from "./selectBox.vue?vue&type=template&id=e4636ce0&scoped=true"
import script from "./selectBox.vue?vue&type=script&lang=js"
export * from "./selectBox.vue?vue&type=script&lang=js"
import style0 from "./selectBox.vue?vue&type=style&index=0&id=e4636ce0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4636ce0",
  null
  
)

export default component.exports